module.exports = __webpack_public_path__ + "img/9788958285670.d92ec453.jpg";